import { KeyDialog, KeyForm, useCreateApiKey } from 'app/domains/api-management';
export function CreateKeyForm(props) {
    const { onClose } = props;
    const { createApiKey, data, reset } = useCreateApiKey();
    const handleClose = () => {
        onClose();
        reset();
    };
    if (data) {
        return <KeyDialog apiKey={data} onClose={handleClose}/>;
    }
    return <KeyForm onSubmit={createApiKey} onClose={onClose}/>;
}
